// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__17DzT"};